import React, { useState } from "react";
import "./CreateNewEvent.scss";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { SlArrowRight } from "react-icons/sl";
import {
  CheckboxInput,
  CheckboxLabel,
  InputLabel,
  InputType,
  SelectBorder,
} from "../../../Global/GlobalFormElement";
import { Description, EventHeading } from "../../../Global/GlobalText";
import TimezoneSelect from "react-timezone-select";
import { MdInfo } from "react-icons/md";
import upload from "../../../../Assets/upload.png";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../../Global/GlobalButton";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../Url/Url";
import { toast } from "react-toastify";
import { setEventIdGet } from "../../../Redux/Users/action";
import { useDispatch } from "react-redux";
import { AwardCategoriesPost } from "../AwardCategories/AwardCategoriesPost";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import { RegistrationForm } from "../RegistrationForm/RegistrationForm";
import { useLoading } from "../../../LoadingContext";
import { EntryForm } from "../EntryForm/EntryForm";
import { IoMdClose } from "react-icons/io";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import styled from "styled-components";


const modules = {
  toolbar: [
    [
      { header: "1" },
      { header: "2" },
      { header: "3" },
      { header: "4" },
      { header: "5" },
      { header: "6" },
      { font: [] },
    ],
    [{ size: [] }],
    ["bold", "underline"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    [{ color: [] }, { background: [] }], // 🎨 Add text color & background color options
  ],
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "background",
];

export const CreateNewEventPost = () => {
  const [selectedButton, setSelectedButton] = useState(1);
  const [selectedTimezone, setSelectedTimezone] = useState();
  const [time, setTime] = useState();
  // Inside CreateNewEventPost component
  const [highestAllowedStep, setHighestAllowedStep] = useState(1);
  const [isStep1Valid, setIsStep1Valid] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    event_name: "",
    closing_date: "",
    closing_time: "",
    email: "",
    event_url: "",
    time_zone: selectedTimezone,
    is_endorsement: 0,
    is_withdrawal: 0,
    is_ediit_entry: 0,
    limit_submission: false,
    submission_limit: "",
    event_description: "",
    industry_type: [],
    additional_email: [],
  });
  const IndustryTypes = [
    "MICE(Meetings, incentives, conferencing, exhibitions)",
    "Non Profit",
    "Corporate",
    "Government",
    "Association",
    "Media",
    "Start up",
    "Educations",
    "Health",
  ];

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const handleIndustryChange = (industry) => {
    if (formData.industry_type.includes(industry)) {
      setFormData({
        ...formData,
        industry_type: formData.industry_type.filter(
          (item) => item !== industry
        ),
      });
    } else {
      setFormData({
        ...formData,
        industry_type: [...formData.industry_type, industry],
      });
    }
    setIsDropdownVisible(false);
  };
  const handleRemoveIndustry = (industry) => {
    // Remove the selected industry from the list
    setFormData({
      ...formData,
      industry_type: formData.industry_type.filter((item) => item !== industry),
    });
  };

  const { setLoading } = useLoading(); //Loader
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const MAX_FILE_SIZE = 2 * 1024 * 1024;

    if (!formData.event_name) newErrors.event_name = "Event name is required.";
    if (!formData.closing_date)
      newErrors.closing_date = "Closing date is required.";
    if (!formData.closing_time)
      newErrors.closing_time = "Closing time is required.";

    if (!formData.email) newErrors.email = "Contact email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Email is invalid.";

    if (!formData.event_url) newErrors.event_url = "Please add unique suffix to the Event UR";
    if (formData.event_url === "https://awardsuite.in/") {
      newErrors.event_url = "Please add unique Suffix to the Event URL.";
    }
    if (files.event_logo && files.event_logo.size > MAX_FILE_SIZE) {
      newErrors.event_logo = "Image size should not exceed 2 MB.";
      toast.error("Image size should not exceed 2 MB.");
  }
  
  if (files.event_banner && files.event_banner.size > MAX_FILE_SIZE) {
      newErrors.event_banner = "Image size should not exceed 2 MB.";
      toast.error("Image size should not exceed 2 MB.");
  }
    return newErrors;
  };

  const [files, setFiles] = useState({
    event_logo: null,
    event_banner: null,
  });

  const [previews, setPreviews] = useState({
    event_logo: null,
    event_banner: null,
  });

  const handleTimezoneChange = (newTimezone) => {
    console.log(newTimezone);
    const timezoneString =
      typeof newTimezone === "string" ? newTimezone : newTimezone?.value;

    setSelectedTimezone(timezoneString);
    setFormData({
      ...formData,
      time_zone: timezoneString,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // setHighestAllowedStep(4);
    // setIsStep1Valid(true);
    setLoading(true);
    // e.preventDefault();
    // const validationErrors = validateForm();
    // setErrors(validationErrors);

    // if (Object.keys(validationErrors).length > 0) {
    //   setLoading(false);
    //   return;
    //     }
    setLoading(true);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      toast.error("Fix errors before saving");
      return;
    }
    const form = new FormData();
    form.append("event_name", formData.event_name);
    form.append("closing_date", formData.closing_date);
    form.append("closing_time", formData.closing_time);
    form.append("email", formData.email);
    form.append("event_url", formData.event_url);
    form.append("time_zone", formData.time_zone);
    form.append("is_endorsement", formData.is_endorsement ? 1 : 0);
    form.append("is_withdrawal", formData.is_withdrawal ? 1 : 0);
    form.append("is_ediit_entry", formData.is_ediit_entry ? 1 : 0);
    form.append("limit_submission", formData.limit_submission ? 1 : 0);

    const submissionLimit = formData.submission_limit
      ? formData.submission_limit
      : 0;
    form.append("submission_limit", submissionLimit);

    form.append("event_description", formData.event_description || null);

    formData.industry_type.forEach((type) =>
      form.append("industry_type[]", type || null)
    );

    formData.additional_email.forEach((email) => {
      form.append("additional_email[]", email);
    });

    if (files.event_logo) form.append("event_logo", files.event_logo);
    if (files.event_banner) form.append("event_banner", files.event_banner);

    try {
      const response = await axios.post(`${EXCHNAGE_URL}/createEvent`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.status === 200) {
        const eventId = response.data.eventId;
        dispatch(setEventIdGet(eventId));
        setSelectedButton(4);
        const nextStep = selectedButton + 1;
        setHighestAllowedStep((prev) => Math.max(prev, nextStep));
        setSelectedButton(nextStep);
        toast.success("Saved! Proceeding to next step");
      }
    } catch (error) {
      console.error("Error creating event", error.response || error);
      toast.error("An error occurred while creating the event");
    } finally {
      setLoading(false);
    }
  };

  console.log(formData.additional_email, "111");

  const handleFileChange = (e) => {
    const { name, files: fileList } = e.target;
    const file = fileList[0];

    if (file) {
      const previewURL = URL.createObjectURL(file);
      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        [name]: previewURL,
      }));
    }

    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: file,
    }));
  };

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  const buttons = [
    { id: 1, label: "Event details" },
    { id: 2, label: "Award Categories" },
    { id: 3, label: "Registration Form" },
    { id: 4, label: "Entry Form" },
  ];

  // const handleClick = (id) => {
  //   setSelectedButton(id);
  // };
  const handleClick = (id) => {
    if (id > highestAllowedStep) {
      toast.error("Complete & save the current step first!");
      return;
    }
    if (id < selectedButton) {
      toast.error("Previous steps are locked");
      return;
    }
    setSelectedButton(id);
  };
  const handleKeyDown = (e) => {
    // If the Enter key is pressed, prevent default form submission
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  console.log(formData.closing_date, formData.closing_time, "asasasas")
  return (
    <div>
      <div className="newevent_div">
        <TitleBar title="Create New Event" />
        <div className="newevent_bg">
          <div className="btn_radio">
            <div className="newevent_btn_click">
              {buttons.map((button, index) => (
                <React.Fragment key={button.id}>
                  <button
                    onClick={() => handleClick(button.id)}
                    className={selectedButton === button.id ? "selected" : ""}
                    disabled={button.id > highestAllowedStep}
                  >
                    {button.label}
                  </button>
                  {index < buttons.length - 1 && <SlArrowRight />}
                </React.Fragment>
              ))}
            </div>
            {/* {selectedButton === 1 && (
              <div className="radio_btn">
                <InputLabel>
                  Plan <span style={{ color: "#c32728" }}>*</span>
                </InputLabel>
                <input
                  type="radio"
                  id="changeColor"
                  name="radio"
                  value="Free"
                  defaultChecked
                />
                <Description>Free</Description>
                <input
                  type="radio"
                  id="changeColor"
                  name="radio"
                  value="Paid"
                  onClick={() => {
                    navigate("/stripe-setting");
                  }}
                />
                <Description>Paid</Description>
              </div>
            )} */}
          </div>

          <div className="newevent_content">
            {selectedButton === 1 && (
              <>
                <div className="post_data">
                  <form
                    className="newevent_form"
                    onSubmit={handleSubmit}
                    onKeyDown={handleKeyDown}
                  >
                    <div className="newevent_row">
                      <div className="newevent_label">
                        <InputLabel>
                          Event Name <span style={{ color: "#c32728" }}>*</span>
                        </InputLabel>
                        <InputType
                          name="event_name"
                          value={formData.event_name}
                          onChange={handleChange}
                          placeholder="Enter Event Name"
                        />

                        {errors.event_name && (
                          <span className="error">{errors.event_name}</span>
                        )}
                      </div>
                      <div className="newevent_label">
                        <InputLabel>
                          Industry type{" "}
                          <span style={{ color: "#c32728" }}></span>
                        </InputLabel>

                        <InputType
                          placeholder="Select Industry Types"
                          value={formData.industry_type.join(", ")}
                          readOnly
                          onClick={toggleDropdown}
                          style={{ cursor: "pointer" }}
                        />
                        <div className="selected-industries">
                          {formData.industry_type.map((industry, index) => (
                            <div key={index} className="selected-industry-item">
                              <span>{industry}</span>{" "}
                              {/* Display the name of the industry */}
                              <IoMdClose
                                className="remove-icon"
                                onClick={() => handleRemoveIndustry(industry)} // Remove industry on click
                              />
                            </div>
                          ))}
                        </div>
                        {isDropdownVisible && (
                          <div className="dropdown_list">
                            {IndustryTypes.map((industry, index) => (
                              <div
                                key={index}
                                className={`dropdown-option ${formData.industry_type.includes(industry)
                                  ? "selected"
                                  : ""
                                  }`}
                                onClick={() => handleIndustryChange(industry)}
                                style={{
                                  cursor: "pointer",
                                  backgroundColor:
                                    formData.industry_type.includes(industry)
                                      ? "#e0e0e0"
                                      : "white",
                                  pointerEvents:
                                    formData.industry_type.includes(industry)
                                      ? "none"
                                      : "auto",
                                }}
                              >
                                {industry}
                              </div>
                            ))}
                          </div>
                        )}

                        {errors.industry_type && (
                          <span className="error">{errors.industry_type}</span>
                        )}
                      </div>
                    </div>

                    <div className="newevent_row">
                      <div className="newevent_closing_label">
                        <div className="clos_label">
                          <InputLabel>
                            Closing Date{" "}
                            <span style={{ color: "#c32728" }}>*</span>
                          </InputLabel>
                          <input
                            type="date"
                            id="closing_date"
                            name="closing_date"
                            value={formData.closing_date}
                            onChange={handleChange}
                            className="calender"
                          />
                          {errors.closing_date && (
                            <span className="error">{errors.closing_date}</span>
                          )}
                        </div>
                        <div className="clos_label">
                          <InputLabel>
                            Closing Time{" "}
                            <span style={{ color: "#c32728" }}>*</span>
                          </InputLabel>

                          <TimePicker
                            onChange={(value) => {
                              setTime(value);
                              setFormData({
                                ...formData,
                                closing_time: value,
                              });
                            }}
                            value={time}
                            disableClock={true}
                          />

                          {errors.closing_time && (
                            <span className="error">{errors.closing_time}</span>
                          )}
                        </div>
                      </div>
                      <div className="newevent_label">
                        <InputLabel>
                          Contact Email{" "}
                          <span style={{ color: "#c32728" }}>*</span>
                        </InputLabel>
                        <InputType
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter Email Address"
                        />

                        {errors.email && (
                          <span className="error">{errors.email}</span>
                        )}
                      </div>
                    </div>

                    <div className="newevent_row">
                      <div className="newevent_label">
                        <div className="event_label_cont">
                          <InputLabel>
                            Event URL{" "}
                            <span style={{ color: "#c32728" }}>*</span>
                          </InputLabel>
                          <EventHeading>https://awardsuite.in/</EventHeading>
                        </div>
                        <InputType
                          name="event_url"
                          // value={formData.event_url}
                          value={formData.event_url || "https://awardsuite.in/"}
                          onChange={(e) => {
                            const defaultUrl = "https://awardsuite.in/";
                            const inputValue = e.target.value;

                            // Prevent deletion of the default URL
                            if (!inputValue.startsWith(defaultUrl)) {
                              return;
                            }

                            // Update form data only if the default URL is intact
                            setFormData({ ...formData, event_url: inputValue });
                          }}
                          placeholder=" https://awardsuite.in/"
                        />
                        {errors.event_url && (
                          <span className="error">{errors.event_url}</span>
                        )}
                      </div>
                      <div className="newevent_label">
                        <InputLabel>
                          Timezone <span style={{ color: "#c32728" }}>*</span>
                        </InputLabel>

                        <TimezoneSelect
                          value={selectedTimezone}
                          onChange={handleTimezoneChange} // Update both selectedTimezone and formData.time_zone
                        />
                      </div>
                    </div>

                    <div className="newevent_row">
                      <div className="newevent_label_lg">
                        <div className="event_label_cont">
                          <InputLabel>
                            Additional Email Addresses
                            <span style={{ color: "#c32728" }}></span>
                          </InputLabel>
                          <div className="cont_icon">
                            <EventHeading>
                              You can add more than one email address separated
                              by comma or semicolon. EG: james@Images.In,
                              lily@images.in
                            </EventHeading>
                            <MdInfo className="mdi_icon" />
                          </div>
                        </div>
                        <InputType
                          name="additional_email"
                          value={formData.additional_email.join(", ")} // Convert the array to a comma-separated string for display
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            // Split the input string by comma or semicolon and update the `additional_email` array
                            const emails = inputValue
                              .split(/[,;]\s*/)
                              .map((email) => email.trim());

                            setFormData({
                              ...formData,
                              additional_email: emails,
                            });
                          }}
                          placeholder="Enter Email Address"
                        />

                        {errors.additional_email && (
                          <span className="error">
                            {errors.additional_email}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="newevent_row">
                      <div className="newevent_label">
                        <div className="newevent_check">
                          <CheckboxInput
                            type="checkbox"
                            name="is_endorsement"
                            checked={formData.is_endorsement}
                            onChange={handleCheckboxChange}
                          />
                          <InputLabel>Require Endorsement </InputLabel>
                        </div>

                        <CheckboxLabel>
                          This option triggers the need for endorsement of award
                          submission by the entry owner. By enabling this,
                          Images will send an endorsement request to the email
                          address entered by the entrant during submission.
                        </CheckboxLabel>
                      </div>

                      <div className="newevent_label">
                        <div className="newevent_check">
                          <CheckboxInput
                            type="checkbox"
                            name="is_withdrawal"
                            checked={formData.is_withdrawal}
                            onChange={handleCheckboxChange}
                          />
                          <InputLabel>Allow Submission Withdrawal</InputLabel>
                        </div>

                        <CheckboxLabel>
                          This allows an entrant to withdraw his/her
                          submissions.
                        </CheckboxLabel>
                      </div>
                    </div>

                    <div className="newevent_row">
                      <div className="newevent_label">
                        <div className="newevent_check">
                          <CheckboxInput
                            type="checkbox"
                            name="is_ediit_entry"
                            checked={formData.is_ediit_entry}
                            onChange={handleCheckboxChange}
                          />
                          <InputLabel>Allow Editing to Entries</InputLabel>
                        </div>

                        <CheckboxLabel>
                          This option allows entrants to edit the submission
                          details.
                        </CheckboxLabel>
                      </div>

                      <div className="newevent_label">
                        <div className="newevent_check">
                          <CheckboxInput
                            type="checkbox"
                            name="limit_submission"
                            checked={formData.limit_submission}
                            onChange={handleCheckboxChange}
                          />
                          <InputLabel>Limit number of submissions</InputLabel>
                        </div>

                        <CheckboxLabel>
                          Restrict the number of submissions entrant can make
                        </CheckboxLabel>
                      </div>
                      {formData.limit_submission && (
                        <div className="newevent_label">
                          <InputLabel>Submission Limit</InputLabel>
                          <InputType
                            type="number"
                            name="submission_limit"
                            value={formData.submission_limit}
                            onChange={handleChange}
                            placeholder="Enter Submission Limit"
                          />

                          {/* {errors.submission_limit && (
                            <span className="error">
                              {errors.submission_limit}
                            </span>
                          )} */}
                        </div>
                      )}
                    </div>

                    <div className="newevent_row">
                      <div className="newevent_label">
                        <InputLabel>Event Logo (2MB Max)</InputLabel>

                        <div className="myevent_img">
                          {previews.event_logo ? (
                            <img
                              src={previews.event_logo}
                              alt="Event Logo Preview"
                              className="preview_img"
                            />
                          ) : (
                            <img src={upload} alt="Default Logo" />
                          )}
                          <input
                            type="file"
                            className="file_input"
                            name="event_logo"
                            accept="image/*"
                            onChange={handleFileChange}
                          />

                          <Description>Browse File, Fitting in area of 120px x 75px</Description>

                          <CheckboxLabel>
                            This option allows entrants to edit the submission
                            details.
                          </CheckboxLabel>
                        </div>
                        {errors.event_logo && (
                          <span className="error">{errors.event_logo}</span>
                        )}
                      </div>

                      <div className="newevent_label">
                        <InputLabel>Event Banner (2MB Max)</InputLabel>

                        <div className="myevent_img">
                          {previews.event_banner ? (
                            <img
                              src={previews.event_banner}
                              alt="Event Banner Preview"
                              className="preview_img"
                            />
                          ) : (
                            <img src={upload} alt="Default Banner" />
                          )}
                          <input
                            type="file"
                            className="file_input"
                            name="event_banner"
                            accept="image/*"
                            onChange={handleFileChange}
                          />
                          <Description>Browse File, Fitting in area of 1300px x 318px</Description>                          <CheckboxLabel>
                            This option allows entrants to edit the submission
                            details.
                          </CheckboxLabel>
                        </div>
                        {errors.event_banner && (
                          <span className="error">{errors.event_banner}</span>
                        )}
                      </div>
                    </div>

                    <div className="newevent_row">
                      <div className="newevent_label_lg">
                        <div className="event_label_cont">
                          <InputLabel>
                            Event Description
                            <span style={{ color: "#c32728" }}></span>
                          </InputLabel>
                        </div>

                        <Contnt>
                          <ReactQuill
                            name="event_description"
                            rows="5"
                            modules={modules}
                            formats={formats}
                            value={formData.event_description || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                event_description: e,
                              })
                            }
                            placeholder="Write something..."
                          />
                        </Contnt>
                        {errors.event_description && (
                          <span className="error">
                            {errors.event_description}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="newevent_btndiv">
                      <GreyBorderButton
                        onClick={() => {
                          navigate("/dashboard");
                        }}
                      >
                        Cancel
                      </GreyBorderButton>

                      <RedBackgroundButton type="submit">
                        Save
                      </RedBackgroundButton>
                    </div>
                  </form>
                </div>
              </>
            )}

            {selectedButton === 2 && (
              <AwardCategoriesPost setSelectedButton={setSelectedButton} />
            )}

            {selectedButton === 3 && (
              <RegistrationForm
                eventBanner={previews.event_banner}
                eventLogo={previews.event_logo}
                eventName={formData.event_name}
                closingTime={formData.closing_time}
                closingDate={formData.closing_date}
                setSelectedButton={setSelectedButton} />
            )}
            {selectedButton === 4 && (
              <EntryForm
                eventBanner={previews.event_banner}
                eventLogo={previews.event_logo}
                eventName={formData.event_name}
                closingTime={formData.closing_time}
                closingDate={formData.closing_date}
                setSelectedButton={setSelectedButton} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};




const Contnt = styled.section`
   display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  width: 100%;
  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: 0px;
    height: 250px;
  }
  .quill {
    width: 100%;
    min-height: 300px;
  }

  .ql-snow .ql-editor img {
    height: 400px;
  }

  .button_div {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .cancel_btn {
      border: 1.5px solid #e7e7e9;
      background-color: #fff;
      color: #0d0c22;
      padding: 10px 20px;
      border-radius: 50px;
      font-size: 15px;
      font-weight: 500;
      width: 130px;
      line-height: 18.15px;
      &:hover {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      }
    }

    .continue_btn {
      border: 1px solid transparent;
      border-radius: 50px;
      background: #6C5FD4;
      color: #fff;
      font-size: 15px;
      font-weight: 500;
      line-height: 18.15px;
      cursor: pointer;
      width: 130px;
      text-align: center;
      padding: 10px 10px;
    }
  }

  @media (max-width: 567px) {
    gap: 0px;
  }

  @media (min-width: 567px) and (max-width: 992px) {
    gap: 0px;
  }
`;